import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dxf-project-portfolio" }
const _hoisted_2 = { class: "lp-hero__content" }
const _hoisted_3 = { class: "lp-hero__content-title-section" }
const _hoisted_4 = {
  key: 0,
  class: "lp-hero__content-secondary-title"
}
const _hoisted_5 = { class: "highlight" }
const _hoisted_6 = {
  key: 1,
  class: "lp-hero__content-primary-title"
}
const _hoisted_7 = { class: "highlight" }
const _hoisted_8 = { class: "dxf-project-portfolio__description" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "card dxf-project-portfolio__attribute-card"
}
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "dxf-project-portfolio__attribute-card-cell" }
const _hoisted_13 = { class: "dxf-project-portfolio__attribute-card-cell-title" }
const _hoisted_14 = { class: "dxf-project-portfolio__attribute-card-cell-value" }
const _hoisted_15 = {
  key: 0,
  class: "dxf-project-portfolio__slider"
}
const _hoisted_16 = { class: "swiper-container slider" }
const _hoisted_17 = { class: "swiper-wrapper" }
const _hoisted_18 = { class: "swiper-slide" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "swiper-container slider-thumbnail" }
const _hoisted_21 = { class: "swiper-wrapper" }
const _hoisted_22 = { class: "swiper-slide" }
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = {
  key: 1,
  class: "dxf-project-portfolio__additional-content"
}
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = {
  key: 2,
  class: "dxf-project-portfolio__related-resources"
}
const _hoisted_27 = { class: "dxf-project-portfolio__related-resources-container" }
const _hoisted_28 = { class: "dxf-project-portfolio__related-resources-body" }
const _hoisted_29 = { class: "dxf-project-portfolio__related-resources-body-col-1" }
const _hoisted_30 = ["href"]
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = { class: "card-title" }
const _hoisted_34 = {
  key: 0,
  class: "card-subtitle"
}
const _hoisted_35 = {
  key: 1,
  class: "card-text"
}
const _hoisted_36 = { class: "dxf-project-portfolio__related-resources-body-col-2" }
const _hoisted_37 = ["href"]
const _hoisted_38 = ["src", "alt"]
const _hoisted_39 = { class: "card-body" }
const _hoisted_40 = { class: "card-title" }
const _hoisted_41 = {
  key: 0,
  class: "card-subtitle"
}
const _hoisted_42 = {
  key: 1,
  class: "card-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: "dxf-project-portfolio__hero lp-hero lp-hero--bg-image",
      style: _normalizeStyle({'background-position': '50% 50%', 'background-image': 'url('+ $props.primaryImage.url +')'})
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "lp-hero__overlay",
        style: {"opacity":"0"}
      }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          ($props.helperText && $props.helperText != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("h3", null, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString($props.helperText), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          ($props.title && $props.title != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("h2", null, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString($props.title), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: "dxf-project-portfolio__detail-body",
        innerHTML: $props.description
      }, null, 8, _hoisted_9),
      ($props.filters.concat($props.attributes).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filters.concat($props.attributes), (attribute) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(attribute.title), 1),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(attribute.value), 1)
                ]))
              }), 256))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    ($props.galleryImages.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.galleryImages, (image) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("img", {
                    src: image.url,
                    alt: image.alt
                  }, null, 8, _hoisted_19)
                ]))
              }), 256))
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "swiper-button-next" }, [
              _createElementVNode("i", { class: "fal fa-chevron-right" })
            ], -1)),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "swiper-button-prev" }, [
              _createElementVNode("i", { class: "fal fa-chevron-left" })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.galleryImages, (image) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("img", {
                    src: image.url,
                    alt: image.alt
                  }, null, 8, _hoisted_23)
                ]))
              }), 256))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($props.additionalContent && $props.additionalContent != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", {
            class: "dxf-project-portfolio__additional-content-body",
            innerHTML: $props.additionalContent
          }, null, 8, _hoisted_25)
        ]))
      : _createCommentVNode("", true),
    ($props.relatedResources.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dxf-project-portfolio__related-resources-title" }, [
              _createElementVNode("h2", null, "Related Resources")
            ], -1)),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.relatedResources, (relatedResource, index) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    (index % 2 == 0)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "card card--horizontal text-decoration-none mb-4",
                          href: relatedResource.url
                        }, [
                          (!!relatedResource.img)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: relatedResource.img.url,
                                class: "card-img-top card--hover-grow",
                                alt: relatedResource.img.alt
                              }, null, 8, _hoisted_31))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("h3", _hoisted_33, _toDisplayString(relatedResource.title), 1),
                            (relatedResource.author || relatedResource.date)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_34, _toDisplayString(relatedResource.author ? relatedResource.author : relatedResource.date? $options.formatDate(relatedResource.date) : ""), 1))
                              : _createCommentVNode("", true),
                            (relatedResource.summary)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(relatedResource.summary), 1))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_30))
                      : _createCommentVNode("", true)
                  ]))
                }), 256))
              ]),
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.relatedResources, (relatedResource, index) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    (index % 2 == 1)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "card card--horizontal text-decoration-none mb-4",
                          href: relatedResource.url
                        }, [
                          (!!relatedResource.img)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: relatedResource.img.url,
                                class: "card-img-top card--hover-grow",
                                alt: relatedResource.img.alt
                              }, null, 8, _hoisted_38))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("h3", _hoisted_40, _toDisplayString(relatedResource.title), 1),
                            (relatedResource.author || relatedResource.date)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_41, _toDisplayString(relatedResource.author ? relatedResource.author : relatedResource.date? $options.formatDate(relatedResource.date) : ""), 1))
                              : _createCommentVNode("", true),
                            (relatedResource.summary)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(relatedResource.summary), 1))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_37))
                      : _createCommentVNode("", true)
                  ]))
                }), 256))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}